import React from 'react';
import PropTypes from 'prop-types';
import './UserDataPanel.scss';

const propTypes = {
    companyData: PropTypes.object,
    email: PropTypes.string,
    tStatus: PropTypes.string,
    couponCode: PropTypes.object,
    showCoupon: PropTypes.bool,
    roleDesc: PropTypes.string,
    cdata: PropTypes.object,
    role: PropTypes.string,
};



export default class UserDataPanel extends React.Component {
    constructor (props) {
        super(props);
    }

    render() {

        const {companyData, email, tStatus, couponCode, showCoupon, roleDesc, cdata, role} = this.props;

        const {name, city, state, postal, reseller_certification, electrician_certification} = companyData;

        const {first_name, last_name} = cdata;



        return(
            <div className='user--info--container'>
                <div className='user-info-col'>
                    <h5 className='table-title'>CONTACT INFO</h5>
                    <table className='user-info-table'>
                        <tbody>
                          <tr>
                              <td><p className='user-title'>Name</p></td>
                              <td><p className='user-content'>{first_name} {last_name}</p></td>
                          </tr>
                          <tr>
                              <td><p className='user-title'>Email</p></td>
                              <td><p className='user-content'>{email}</p></td>
                          </tr>
                          <tr>
                              <td><p className='user-title'>Role</p></td>
                              <td><p className='user-content'>{roleDesc}</p></td>
                          </tr>
                        </tbody>
                    </table>
                </div>
                <div className='user-info-col'>
                    <h5 className='table-title'>BUSINESS INFO</h5>
                    <table className='user-info-table'>
                        <tbody>
                            <tr>
                                <td><p className='user-title'>Business Name</p></td>
                                <td><p className='user-content'>{name}</p></td>
                            </tr>
                            {this.props.role === 'user' || this.props.role === 'electrician' ?
                                <tr>
                                    <td><p className='user-title'>Electrician Certification #</p></td>
                                    <td><p className='user-content'>{electrician_certification}</p></td>
                                </tr> :
                                null
                            }
                            {this.props.role === 'user' || this.props.role === 'electrician' || this.props.role === 'distributor' ?
                                <tr>
                                    <td><p className='user-title'>Reseller Certification #</p></td>
                                    <td><p className='user-content'>{reseller_certification}</p></td>
                                </tr> :
                                null
                            }
                            <tr>
                                 <td><p className='user-title'>City</p></td>
                                 <td><p className='user-content'>{city}</p></td>
                            </tr>
                            <tr>
                                <td><p className='user-title'>State</p></td>
                               <td><p className='user-content'>{state}</p></td>
                             </tr>
                        </tbody>
                    </table>
                </div>
                <div className='user-info-col-last'>
                    <h5 className='table-title'>TRAINING STATUS: {tStatus}</h5>
                    {this.props.showCoupon === true ?
                        <div className='promo-code-holder'>
                            <p>ROOM BUNDLE PROMOTION CODE</p>
                            <div>{couponCode}</div>
                            <p>You will receive an email with a cart order containing your free Room Bundle within <nobr>2 business days.</nobr> If you have any questions, please email us at <a href={'mailto:orders@noonhome.com'}>orders@noonhome.com</a></p>

                        </div> :
                        null
                    }
                </div>
            </div>
        )
    }
}

UserDataPanel.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/UserDataPanel/index.js